import React, { useEffect,useMemo } from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from 'react-redux';
import { useRealtimeUnits, useRealtimeAssets } from 'Core/hooks';

import { Grid } from '@mui/material';
import { Form } from 'Components';
import TagsManage from 'Modules/.common/components/TagsManage';
import { INSPECTION_ALERT_TYPE } from 'Modules/evirPx/.globals/constants.ts';

const Step4 = (props) => {

    const { currentAlert, value, onChange, formRef, nextStep } = props
    const { messages } = useIntl()
    const units = useRealtimeUnits({ trackFields: ['id', 'name', 'label', 'disabled', 'driverId', 'vehicleStatusId', 'tags'] });
    const assets = useRealtimeAssets({ trackFields: ['id', 'name', 'vin', 'make', 'model', 'tags'] });
    
    const isInspectionAlert = currentAlert?.code === INSPECTION_ALERT_TYPE

    const unitsList = useMemo(() => {
      return units.map(unit => ({
        id: unit?.id,
        label: unit?.label
      }));
    }, [units]);

    const assetsList = useMemo(() => {
      return assets.map(asset => ({
        id: asset?.id,
        label: asset?.label
      }));
    }, [assets]);

    const entities = {
        singleUnit: { id: "units", label: messages['alertsNewAlert_tab_unit_units'] || "Units" },
        Unit: { id: "Unit", label: messages['alertsNewAlert_tab_unit_units'] || "Units" },
        Driver: { id: "Driver", label: messages['alertsNewAlert_tab_unit_drivers'] ||"Drivers" },
        Asset: { id: "Asset", label: messages['alertsNewAlert_tab_unit_assets'] || "Assets" }, 
        All: { id: "All", label: messages['alertsNewAlert_tab_unit_all'] || "All" },
    };

    const assignEntities = (entitiesArray) => entitiesArray?.map((entity) => entities[entity]);
    const normalizeEntityId = (item, entityName) => {
      if (entityName === "Driver") {
        return item?.driverId ?? item?.id;
      }

      const rawId = item?.id ?? item?.unitId ?? item?.assetId;
      const idAsString = String(rawId ?? "");
      const isNumericId = /^-?\d+$/.test(idAsString);

      if (isNumericId && ["Unit", "Asset"].includes(entityName)) {
        return Number(idAsString);
      }

      return rawId;
    };

    useEffect(() => {
        let assingEntity = "All"
        let assignedTo = value.assignedTo?.map((item) => {
            // For Inspections, default to Asset; otherwise Unit
            const defaultEntity = isInspectionAlert ? "Asset" : "Unit";
            assingEntity = item.id == "-1" ? "All" : (item.name == "Tag" ? defaultEntity : item.name)
            return item.id == "-1" ? { id: "-1", name: "All", label: "All" } : { ...item, name: item?.name,label: item?.label || item.__typename }
        });

        //eval have all
        if(assignedTo?.length > 0 && assignedTo?.find((item) => item.id == "-1")){
            assignedTo = [{ id: "-1", name: "All", label: "All" }];
            assingEntity = "All"
        }

        if (!assignedTo?.length) {
            assignedTo = [{ id: "-1", name: "All", label: "All" }];
        }
        
        onChange({ ...value, assingEntity: assingEntity, assignedTo: assignedTo })
    }, [])

    return (
      <Form
        ref={formRef}
        noSubmit
        onValidSubmit={() => {
          nextStep();
        }}
        onSubmit={() => {
          return value.assignedTo.length > 0;
        }}
      >
        
        <Grid>
          {value.assignedTo?.length == 0 && (
            <div className="text-danger" style={{ paddingTop: 5 }}>
              {value.assingEntity == "Unit"
                ? messages["alertsNewAlert_unitsValidation"]
                : value.assingEntity == "Asset"
                ? messages["alertsNewAlert_assetsValidation"] || "Please select at least one asset"
                : messages["alertsNewAlert_driversValidation"]}
            </div>
          )}
          {value.assingEntity && (
            // <TagPickerSelector
            //     entities={assignEntities(currentAlert.entities)}
            //     value={value.assignedTo?.map((item) => (item.id == "-1" ? { id: "-1", name: "All", label: "All" } : { ...item, name: item?.name || item.__typename })) || []}
            //     entity={entities[value.assingEntity || "All"]}
            //     onChangeEntity={(newSelectedEntity) => {
            //         if (newSelectedEntity.id == "All")
            //             onChange({ ...value, assingEntity: newSelectedEntity.id, assignedTo: [{ id: "-1", name: "All" }] })
            //         else
            //             onChange({ ...value, assingEntity: newSelectedEntity.id, assignedTo: [] })
            //     }}
            //     onChange={(selectedItems, entity) => {
            //         onChange({
            //             ...value,
            //             assignedTo: selectedItems.map(selectedItem => {
            //                 return { ...selectedItem, label: entity.id }
            //             }),
            //             assingEntity: entity
            //         })
            //     }}
            //     unitVersionIds={currentAlert?.unitVersionIds}
            //     conditions={currentAlert?.conditions}
            //     onlyTagsWithEntities={true}
            //     showUntaggedAll={false}
            // />
            <TagsManage
              entities={assignEntities(currentAlert.entities)}
              value={
                  (value.assignedTo || []).map((item) => {
                    // Handle the special case for "All"
                    if (item.id === "-1") {
                      return { id: "-1", name: "All", label: "All" };
                    }

                    const entityName = item?.name || item?.__typename || value.assingEntity;
                    const normalizedId = normalizeEntityId(item, entityName);

                    // Determine label based on entity type
                    let entityLabel = item?.label;
                    if (item?.name === "Unit") {
                      entityLabel = unitsList.find((unit) => String(unit.id) === String(normalizedId))?.label;
                    } else if (item?.name === "Asset") {
                      entityLabel = assetsList.find((asset) => String(asset.id) === String(normalizedId))?.label;
                    }
                    
                    const label = (entityLabel || item?.__typename || "").trim();

                    return {
                      ...item,
                      id: normalizedId,
                      driverId: entityName === "Driver" ? normalizedId : item?.driverId,
                      name: item?.name,
                      label,
                    };
                  })
                }
              entitySelected={entities[value.assingEntity || "All"]}
              setEntitySelected={(newSelectedEntity) => {
                if (newSelectedEntity.id == "All")
                  onChange({
                    ...value,
                    assingEntity: newSelectedEntity.id,
                    assignedTo: [{ id: "-1", name: "All" }],
                  });
                else
                  onChange({
                    ...value,
                    assingEntity: newSelectedEntity.id,
                    assignedTo: (value.assignedTo || []).filter((item) => item?.id !== "-1"),
                  });
              }}
              onChange={(selectedItems, entity) => {
                onChange({
                  ...value,
                  assignedTo: selectedItems.map((selectedItem) => {
                    return {
                      ...selectedItem,
                      id: normalizeEntityId(selectedItem, entity.id),
                      driverId: entity.id === "Driver" ? normalizeEntityId(selectedItem, entity.id) : selectedItem?.driverId,
                      name: selectedItem?.name || selectedItem?.__typename || entity.id,
                      label: selectedItem?.label || selectedItem?.name || entity.id,
                    };
                  }),
                  assingEntity: entity?.id || entity,
                });
              }}
              mode="list"
              disableUntaggedSelection={true}
              enableSelectAll={false}
            />
          )}
        </Grid>
      </Form>
    );
}
export default Step4;